import { render, staticRenderFns } from "./card-table.vue?vue&type=template&id=489228f5&scoped=true"
import script from "./card-table.vue?vue&type=script&lang=js"
export * from "./card-table.vue?vue&type=script&lang=js"
import style0 from "./card-table.vue?vue&type=style&index=0&id=489228f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489228f5",
  null
  
)

export default component.exports